import { useEffect, useRef, useState } from 'react';
import { useCoachThread } from '../hooks/useCoachThread';
import { CoachMessage } from './CoachMessage';
import { CoachCompose } from './CoachCompose';

// Cross-cutting AI coach panel. Lives across all top-level tabs of the
// Portfolio Executive Companion workspace.
//
// Public API:
//   <Coach context={string} onGoto={(slug) => void} />
//
//   - context : opaque slug. Coach uses it only to fetch the right thread; it
//               does not know what each slug means in the host UI.
//   - onGoto  : called when a coach CTA fires. Host decides what to navigate to.

export function Coach({ context = 'hub', onGoto = () => {} }) {
  const { messages, loading, error } = useCoachThread(context);
  const scrollRef = useRef(null);
  const [picks, setPicks] = useState({});

  const handlePick = (msgId, opt) =>
    setPicks((prev) => ({ ...prev, [msgId]: opt.k }));

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [context, messages.length]);

  return (
    <aside className="coach">
      <div ref={scrollRef} className="flex-1 min-h-0 overflow-y-auto">
        {loading && (
          <div className="px-4 py-3 font-mono text-mono-tag text-ink-3 uppercase">Loading…</div>
        )}
        {error && (
          <div className="px-4 py-3 font-mono text-mono-tag text-danger uppercase">
            Coach unavailable
          </div>
        )}
        {!loading && !error && messages.map((m) => (
          <CoachMessage
            key={m.id}
            message={m}
            pickedKey={picks[m.id]}
            onPick={(opt) => handlePick(m.id, opt)}
            onCta={onGoto}
          />
        ))}
      </div>

      <CoachCompose onSend={() => { /* Phase J: wire to POST /coach/messages */ }} />
    </aside>
  );
}

export default Coach;
